// extracted by mini-css-extract-plugin
export default {"recipientBlock":"PunchupBulkConfirmation_recipientBlock__JYMD+","email":"PunchupBulkConfirmation_email__Lg8Cl punchupTextSecondary"};